import firebase from '../../firebase';

export default async function getUserFleets() {
    return firebase.functions().httpsCallable('getUserFleets')();
}
